import {useEffect, useState} from "react";

export const useThemeDetector = () => {
    const getMatchMedia = () => window.matchMedia("(prefers-color-scheme: dark)");

    const [isDarkMode, setDarkMode] = useState(getMatchMedia().matches);

    const mqListener = (e) => {
        setDarkMode(e.matches);
    }

    useEffect(() => {
        const mq = getMatchMedia();
        mq.addEventListener('change', mqListener);

        return () => {
            mq.removeEventListener('change', mqListener);
        }

    }, []);

    return isDarkMode;
}
